const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export function fetchJson(url, opts) {
  const token = localStorage.getItem('token');
  return fetch(`${BASE}${url}`, {
    ...opts,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, ...(opts?.headers || {}) },
  }).then(async r => {
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.message || 'Request failed');
    return data;
  });
}

export const listCases = () => fetchJson('/api/dpr/cases');
export const getCase = (id) => fetchJson(`/api/dpr/cases/${id}`);
export const createCase = (body) => fetchJson('/api/dpr/cases', { method: 'POST', body: JSON.stringify(body) });
export const updateCase = (id, body) => fetchJson(`/api/dpr/cases/${id}`, { method: 'PUT', body: JSON.stringify(body) });
export const deleteCase = (id) => fetchJson(`/api/dpr/cases/${id}`, { method: 'DELETE' });
export const generateNarrative = (id) => fetchJson(`/api/dpr/cases/${id}/narrative/generate`, { method: 'POST' });
